export const salesRevokeConstants = {
  LIST_SALES_REVOKE_REQUEST: 'LIST_SALES_REVOKE_REQUEST',
  LIST_SALES_REVOKE_SUCCESS: 'LIST_SALES_REVOKE_SUCCESS',
  RETURN_ARTICLES_SALES_MASSIVE: 'RETURN_ARTICLES_SALES_MASSIVE'
};
